<template>
	<div class="page-container">
		<div class="back_left" @click="$router.go(-1)" />
		<div class="headers">
			<h1 style="margin-top: 10px;">开通大额提现</h1>
		</div>
		<div class="imggw">
			<img width="150px" src="../images/user/11wh0-eeva3.png" alt="">
		</div>
		<div class="form-wrapper">
			<form class="card-form">
				<div class="form-title">开通钱包，享受大额提现</div>
				<div class="form-money">金额：<span>{{ data.big_paymentAmount }}元</span></div>
				<div class="confirm-text">
					<span>开通大额提现钱包，</span>
					<span style="margin-top: 10px;">即可享受专属大额且无限制提现！</span>
				</div>
			</form>
		</div>
		<div class="payment-container">
			<span>选择支付方式</span>
			<div v-for="item in paymentMethods" :key="item.value" class="payment-method"
				:class="{ active: selectedMethod === item.value }" @click="selectMethod(item.value,item.id)">
				<input type="radio" :id="item.value" :value="item.value" v-model="selectedMethod" hidden>
				<img :src="item.icon" class="method-icon">
				<label :for="item.value">{{ item.label }}</label>
			</div>
		</div>
		<button class="confirm-btn" @click="handlePayment">立即支付</button>
	</div>
</template>

<script>
	import Fetch from '../../utils/fetch';
	export default {
		data() {
			return {
				data: {},
				selectedMethod: '',
				paymentMethods: [{
						value: '8010',
						id: '2',
						label: '支付宝支付',
						icon: require('../images/user/payzfb.png')
					},
					{
						value: '8009',
						id: '3',
						label: '微信支付',
						icon: require('../images/user/paywx.png')
					},
					{
						value: '8011',
						id: '4',
						label: '云闪付支付',
						icon: require('../images/user/payysf.png')
					}
				]
			}
		},
		created() {
			this.$parent.footer('user', false);
		},
		mounted() {
			this.start();
		},
		methods: {
			start() {
				Fetch('/user/info').then((r) => {
					this.data = r.data;
				});
			},
			selectMethod(item, id) {
				this.selectedMethod = item
				this.id = id
			},
			handlePayment() {
				if (!this.selectedMethod) {
					this.$toast({
						className: "toastName",
						message: '请选择支付方式',
					});
					return false;
				}
				const productId = this.selectedMethod;
				const money =  this.data.big_paymentAmount;
				const id = this.id;
				const type = '开通大额提现';
				Fetch('/user/recharge_type', {
					productId,
					money,
					id,
					type
				}).then(res => {
					window.location.href = res.data.payUrl;
					// window.open(res.data.payUrl, '_blank');
					this.$toast({
						className: "toastName",
						message: res.info['zh_cn'] ? res.info['zh_cn'] : res.info,
					});
				}).catch(error => {
					this.$toast({
						className: "toastName",
						message: '操作失败，请联系客服',
					});
				});
			},
		}
	}
</script>

<style lang="less" scoped>
	.page-container {
		height: 800px;
		background: url(../images/user/redimg.jpg) no-repeat center;
		background-size: 112% 102%;
		position: relative;
		// height: 100vh;
	}

	.headers {
		color: #ffd08e;
		font-size: 24px;
		position: absolute;
		top: 10%;
		left: 50%;
		transform: translate(-50%, -50%);
		width: 100%;
		text-align: center;
	}

	.form-wrapper {
		position: absolute;
		top: 41%;
		left: 50%;
		transform: translate(-50%, -50%);
		width: 90%;
		max-width: 500px;
		background: #fff;
		padding: 0 20px 20px;
		border-radius: 8px;
		box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
	}

	.card-form h2 {
		text-align: center;
		margin-bottom: 20px;
	}

	.form-title {
		width: 200px;
		margin: 0 auto 10px;
		background: #d7000f;
		color: #fff;
		border-radius: 0 0 12px 12px;
		padding: 8px 0;
		font-size: 16px;
		text-align: center;
		margin-bottom: 15px;
		font-weight: bold;
	}

	.form-money {
		width: 200px;
		margin: 0 auto 10px;
		color: #585858;
		font-size: 16px;
		text-align: center;
		margin-bottom: 15px;
		font-weight: bold;
	}

	.form-money span {
		color: #d7000f;
		font-size: 20px;
	}

	.form-group {
		margin-bottom: 20px;
		// display: flex;
		// justify-content: space-around;
		// align-items: center;
	}

	label {
		display: block;
		margin-bottom: 8px;
	}

	input {
		width: 100%;
		padding: 10px;
		border: 1px solid #ddd;
		border-radius: 4px;
	}

	.preview img {
		max-width: 100%;
		max-height: 200px;
		margin-top: 10px;
	}

	.confirm-btn {
		position: absolute;
		bottom: 25px;
		width: 90%;
		max-width: 500px;
		left: 50%;
		transform: translateX(-50%);
		padding: 12px 40px;
		background: #ffdf9a;
		color: red;
		border: none;
		border-radius: 4px;
		font-size: 18px;
		font-weight: bold;
		cursor: pointer;
	}

	.confirm-text {
		font-weight: bold;
		text-align: center;
		display: flex;
		flex-direction: column;
		font-size: 15px;
		color: red;
	}

	.add-card {
		display: block;
		width: 100%;
		height: 150px;
		line-height: 150px;
		background: #fff0e0;
		color: #d7000f;
		border: 1px dashed #d7000f;
		border-radius: 6px;
		font-size: 15px;
		text-align: center;
		margin-bottom: 12px;
		cursor: pointer;
	}

	.tip {
		color: #d7000f;
		font-size: 12px;
		text-align: center;
		margin-top: 8px;
		margin-bottom: 10px;
	}

	.imggw {
		position: absolute;
		top: 18%;
		left: 50%;
		transform: translateX(-50%);
	}

	.payment-container {
		max-width: 500px;
		margin: 0 auto;
		position: absolute;
		top: 70%;
		left: 50%;
		transform: translate(-50%, -50%);
		width: 90%;
		background: #fff;
		padding: 20px;
		border-radius: 8px;
	}

	.payment-container span {
		color: #585858;
		font-size: 15px;
		font-weight: 600;
	}

	.payment-method {
		display: flex;
		align-items: center;
		padding: 15px;
		border: 1px solid #ddd;
		border-radius: 8px;
		margin-bottom: 10px;
		cursor: pointer;
		transition: all 0.3s;
	}

	.payment-method.active {
		border-color: #1989fa;
		background-color: #f5faff;
	}

	.payment-method:first-of-type {
		margin-top: 15px;
	}

	.method-icon {
		width: 30px;
		height: 30px;
		margin-right: 15px;
	}
</style>